/**
 * Created by debojyoti on 7/10/15.
 */

'use strict';

angular.module('mediacloudApp')
    .factory('CollectionService', function ($resource) {
        return {
            GetCollection: $resource('api/collection'),
            GetCollectionTree: $resource('api/collection/tree'),
            GetCollectionContent: $resource('api/collection/content'),
            GetFeaturedAsset: $resource('api/collection/asset/featured'),
            GetAllCollections: $resource('api/collections'),
            getCollections: function(args, callback){
                var cb = callback || angular.noop,
                    resource = $resource('api/collections');

                return resource.get({ type: args.type, limit: args.limit, offset: args.offset, paginated: args.paginated, rw: args.rw },
                    function(response){
                        return cb(response);
                    }, function(err){
                        return cb(err);
                    }).$promise;
            },
            getSingleCollection: function(args, callback){
                var cb = callback || angular.noop,
                    resource = $resource('api/collection');

                return resource.get({ type: args.type, cid: args.cid },
                    function(response){
                        return cb(response);
                    }, function(err){
                        return cb(err);
                    }).$promise;
            },
            GetHomeCollections: $resource('api/home/collections'),
            ToggleDropBox: $resource('api/course/dropbox/toggle'),
            ToggleAssignmentTool: $resource('api/course/assignments/toggle'),
            UpdateCollectionMetadata: $resource('api/collection/metadata/update', {}, {
                update : {
                    method: 'PUT', params: {}, isArray: false
                }
            }),
            GetStudentDropBoxCollection: $resource('api/course/dropbox'),
            GetStudentAssignmentCollection: $resource('api/course/assignments'),
            GetNewMediaInboxSubmissions: $resource('api/course/mediainbox/submissions'),
            CreateCollection: $resource('api/collection/create'),
            CopyCollection: $resource('api/collection/copy/all'),
            copyCollection: function(args, callback){
                var cb = callback || angular.noop,
                    resource = $resource('api/collection/copy/all');

                return resource.save({ destinationCid: args.destinationCid, cidList: args.cidList },
                    function(response){
                        return cb(response);
                    }, function(err){
                        return cb(err);
                    }).$promise;
            }
        };
    });
